import React, { useState, useEffect } from 'react';
import '../App.css';
import Givers from './GetGivers.jsx';
import CustomSelect from './CustomSelect';
import Button from '@material-ui/core/Button';
import { getWilayaList } from '@dzcode-io/leblad';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

function App() {

    const [giverList, setGiverList] = useState([]);

    function handleWilayasChanges(event) {
        fetchGiverList(event.value)
    }

    async function fetchGiverList(wilaya) {
        try {
            const requestUrl = 'https://dzoxygen.000webhostapp.com/getGiverByWilaya.php?wilaya=' + wilaya;
            const response = await fetch(requestUrl);
            const responseJson = await response.json();
            setGiverList(responseJson.data)
        } catch {
            console.log("error")
        }
    }

    useEffect(() => {
        fetchGiverList(31)
    }, []);

    const allWilayasDetails = getWilayaList();

    const options = allWilayasDetails.map(wilaya => ({ label: wilaya.name, value: wilaya.mattricule }))

    const ExternalRedirect = ({ to, ...routeProps }) => {
        return <Route {...routeProps} render={() => window.location = to} />;
    };

    return (
        <div>
            <div className="App">
                <CustomSelect className="CustomSelect" defaultValue={options[30]} onChange={handleWilayasChanges} options={options} label_fr="Pour trouver de l'oxygen dans votre wilaya vous devez la choisir du menu suivant : " label_ar="للعثور على الأكسجين في ولايتك ، يجب عليك اختياره من القائمة التالية :" />
                <Givers className="GetList" giverList={giverList} />
            </div>
        </div>
    );
}

export default App;
